import { Injectable } from "@angular/core";
import { LogoutWarningActions } from "./logout-warning/logout-warning-actions";

@Injectable()
export class AuthTimer {
    private timer$;
    endTime = 0;
    msLeft = 0;
    constructor(
        private actions: LogoutWarningActions) {
    }

    private timerCallback = (leftTime: any) => {
        if (leftTime > 0 && leftTime < 1000) {
            this.actions.setVisible();
        }
    };

    public startTimer(time: number): void {

        if (this.timer$) {
            this.timer$.unsubscribe();
        }
        this.setTimes(time);
        this.calculateTime(time);
    }
    public setTimes(time: number): void {
        this.endTime = (+new Date()) + 1000 * (time / 1000) + 500;
        this.msLeft = this.endTime - (+new Date());
    }
    public calculateTime(time: number): void {
        let i = 0;
        while (i <= (time / 1000) + 1) {
            const _time = new Date( this.msLeft );
            setTimeout(() => {
                this.msLeft > 1000 ? this.msLeft = this.endTime - (+new Date()) : this.timerCallback(this.msLeft);
            },
            (_time.getUTCMilliseconds() + 500) * i + 1);
            i++;
        }
    }

}
